<po-page-default p-title="Relatório Médicos - Domínio" [p-breadcrumb]="breadcrumb">
    <div class="page-summary">
        <div class="page-summary-icon"><span class="an an-first-aid"></span></div>
        <div class="page-summary-text">
            <p class="po-font-subtitle">Relatório de Médicos</p>
            <p class="page-summary-hint">
                Gere o relatório de Fechamento Médicos com base nas informações do sistema Domínio.
                Após o processamento, o relatório será enviado para o e-mail cadastrado em seu usuário.
            </p>
        </div>
    </div>

    <form #form="ngForm" (ngSubmit)="requestMedicos(form)">
        <!-- Configuração -->
        <div class="rpt-section po-mt-3">
            <div class="rpt-section-header">
                <i class="an an-gear"></i>
                <span>Configuração do Relatório</span>
            </div>
            <div class="rpt-section-body">
                <div class="po-row">
                    <app-empresa-combo class="po-lg-4 po-md-6 po-sm-12" name="idEmpresa" [(ngModel)]="idEmpresa"
                        label="Empresa" p-required="true"
                        placeholder="Buscar por código ou nome da empresa..."
                        help="Digite o código (Domínio) ou o nome da empresa para buscar.">
                    </app-empresa-combo>
                    <po-datepicker-range class="po-lg-4 po-md-6 po-sm-12" p-label="Período" p-name="periodo"
                        name="periodo" [(ngModel)]="periodo" p-placeholder-start="Data Inicial"
                        p-placeholder-end="Data Final" p-help="Informe o período desejado para o relatório"
                        [p-required]="true">
                    </po-datepicker-range>
                </div>
                <div class="rpt-action-row po-mt-3">
                    <po-button p-label="Gerar Relatório de Médicos" (p-click)="requestMedicos(form)"></po-button>
                </div>
            </div>
        </div>

        <!-- Como funciona -->
        <div class="rpt-section po-mt-3">
            <div class="rpt-section-header">
                <i class="an an-lightbulb"></i>
                <span>Como Funciona</span>
            </div>
            <div class="rpt-section-body">
                <div class="rpt-info-steps">
                    <div class="rpt-info-step">
                        <span class="rpt-step-number">1</span>
                        <div class="rpt-step-content">
                            <p class="rpt-step-title">Selecione a Empresa e o Período</p>
                            <p class="rpt-step-desc">Escolha a empresa desejada e defina o intervalo de datas para o relatório.</p>
                        </div>
                    </div>
                    <div class="rpt-info-step">
                        <span class="rpt-step-number">2</span>
                        <div class="rpt-step-content">
                            <p class="rpt-step-title">Gere o Relatório</p>
                            <p class="rpt-step-desc">Clique em "Gerar Relatório de Médicos" para iniciar o processamento.</p>
                        </div>
                    </div>
                    <div class="rpt-info-step">
                        <span class="rpt-step-number">3</span>
                        <div class="rpt-step-content">
                            <p class="rpt-step-title">Receba por E-mail</p>
                            <p class="rpt-step-desc">O relatório será enviado para o e-mail cadastrado em seu usuário. O processo pode levar alguns minutos.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
